export const startFreeTrialGTM = ({ type = null }) => {
  let eventName = 'Start_free_Trial';
  if (type !== null) {
    eventName += '_' + type;
  }
  if (!window.dataLayer) window.dataLayer = [];
  dataLayer.push({
    event: eventName,
  });
};

export const getStartedPricingGTM = ({ type = 'Plus_Monthly' }) => {
  dataLayer.push({
    event: 'Get_Started_' + type,
  });
};

export const payNowGTM = ({ plan, frequency, promo = null, value = 0 }) => {
  let eventName = 'payNow_' + plan + '_' + frequency;
  if (promo !== null) eventName += '_' + promo;
  if (!window.dataLayer) window.dataLayer = [];
  dataLayer.push({
    event: eventName,
    event_value: value,
    event_currency: 'USD',
  });
};

export const learnMorePricingGTM = () => {
  dataLayer.push({
    event: 'Learn_more_Platinum',
  });
};

export const paySoundcastSubGTM = ({ type, value = 0 }) => {
  let eventName = 'Pay_Soundcast_Sub' + (type === 'annually' ? '_Annually' : '_Monthly');
  if (!window.dataLayer) window.dataLayer = [];
  dataLayer.push({
    event: eventName,
    event_value: value,
    event_currency: 'USD',
  });
};
